import script from "./SMSBalance.vue?vue&type=script&lang=ts&setup=true"
export * from "./SMSBalance.vue?vue&type=script&lang=ts&setup=true"

import "./SMSBalance.vue?vue&type=style&index=0&id=da5e82ac&scoped=true&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da5e82ac"]])

export default __exports__